import type { SidebarItem } from '@bv/router';

const sidebarItems: SidebarItem[] = [
  {
    title: 'Normalizer',
    route: { name: 's-normalizer-list' },
  },
  {
    title: 'Roles and permissions',
    route: { name: 's-roles-list' },
  },
  {
    title: 'Audit logs',
    route: { name: 's-logs' },
  },
];

export default sidebarItems;
